<template>
  <router-view></router-view>
</template>
<script setup>
import { onMounted } from 'vue'
onMounted(() => {
  console.log('App mounted')
  let loading = document.getElementById("loader-wrapper")
  if (loading !== null) {
    loading.remove()
  }
})
</script>
